import React, { useEffect, useState } from 'react'
import AwsConfig from '../../Config/AwsConfig'
import MovieImagePresignedUrl from '../../Services/Queries/Movieimagepresignedurl'
import { v4 as uuidv4 } from 'uuid'
import axios from 'axios'
import PosterCdnCheck from './PosterCdnCheck'

const CreateListPoster = props => {
  const {
    imagePreview,
    setImagePreview,
    selectedListType,
    HorizontalImage,
    setHorizontalImage,
    setvalueEdited,
  } = props

  const [selectedImage, setSelectedImage] = useState('')
  const [galleryType] = useState('movie')
  const [imageValue, setImageValue] = useState('')
  const [requiredImageSize, setRequiredImageSize] = useState(true)

  const selectImage = event => {
    setSelectedImage(event.target.files[0])
    setImageValue('')
  }

  const horizontalImage = event => {
    setHorizontalImage(event.target.naturalHeight < event.target.naturalWidth)
  }

  const generateRandomId = async () => uuidv4()

  const determineMoviePath = () =>
    galleryType === 'person' ? AwsConfig.personPathUrl : AwsConfig.moviePathUrl

  const generateKey = (moviePath, randomId) => `${moviePath}${randomId}.jpeg`

  const prepareFormData = signedURLObject => {
    const formData = new FormData()
    Object.entries(signedURLObject.data.fields).forEach(([fieldName, value]) => {
      formData.append(fieldName, value)
    })
    formData.append('file', selectedImage)
    return formData
  }

  const uploadImageToServer = async (signedURL, formData) => {
    await axios({
      method: 'post',
      url: signedURL,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  }

  const uploadSelectedImage = async () => {
    try {
      const maxSize = 2 * 1024 * 1024
      const randomId = await generateRandomId()
      const moviePath = determineMoviePath()
      const key = generateKey(moviePath, randomId)

      if (selectedImage.size > maxSize) {
        setRequiredImageSize(false)
        return
      }

      setRequiredImageSize(true)
      const params = {
        key,
        mimeType: 'image/jpeg',
      }

      const preSignedURLObject = await MovieImagePresignedUrl(params)
      const signedURLObject = JSON.parse(preSignedURLObject.signedObject)
      const signedURL = signedURLObject.data.url

      const formData = prepareFormData(signedURLObject)
      await uploadImageToServer(signedURL, formData)

      setImagePreview(key)
      setvalueEdited(true)
    } catch (error) {
      console.error('Error during image upload:', error)
    }
  }

  useEffect(() => {
    if (selectedImage !== '') {
      uploadSelectedImage()
    }
  }, [selectedImage])

  return (
    <>
      <label>
        {selectedListType ? selectedListType : 'Movie'}ListImage:
        <span className='mandatory'>*</span>
      </label>
      <input
        type='file'
        value={imageValue}
        className='form-control m-2'
        accept='image/*'
        placeholder='please enter gallery image'
        onChange={selectImage}
        title=' '
        style={{ color: imagePreview ? 'black' : 'transparent' }}
      />
      <div>
        <div
          style={{
            position: 'relative',
            left: '165px',
            top: '36px',
          }}
        >
          {imagePreview.length > 1 && (
            <button
              className='remove btn btn-danger'
              type='button'
              onClick={() => {
                setHorizontalImage(false)
                setImagePreview('')
              }}
            >
              X
            </button>
          )}
        </div>
        {imagePreview && (
          <div style={{ display: 'flex', gap: '10px' }}>
            <img
              src={PosterCdnCheck(imagePreview)}
              className='posterimage'
              alt='poster-url'
              width='200'
              height='200'
              onLoad={e => horizontalImage(e)}
            />
          </div>
        )}
        {!HorizontalImage && (
          <span className='mandatory1'>Please select a horizontal Image</span>
        )}
        {!requiredImageSize && (
          <span className='mandatory1'>Image size should not be more than 2mb</span>
        )}
      </div>
    </>
  )
}

export default CreateListPoster
